'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrayIntersection = require('../core/utilities/arrayIntersection');

var _arrayIntersection2 = _interopRequireDefault(_arrayIntersection);

var _AuthStates = require('self-service-api/constants/AuthStates');

var _validators = require('self-service-api/core/validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var availableCurrenciesAdapter = function availableCurrenciesAdapter(productData, _ref) {
  var itemConfigurations = _ref.itemConfigurations;

  (0, _validators.validateMinimumAuthState)(productData, _AuthStates.NOT_AUTHED);
  var products = productData.products,
      customerCurrencyCode = productData.customerCurrencyCode;

  // Customer currency code exists when a user has already purchased
  // one of our products in apollo. We want to lock them into that
  // curerncy and therefore we only return that value.

  if (customerCurrencyCode) {
    return [customerCurrencyCode];
  }

  var _getAvailableCurrencies = function _getAvailableCurrencies(_ref2) {
    var merchandiseId = _ref2.merchandiseId;

    var product = products[merchandiseId];

    if (!product) {
      return [];
    }

    if (product.pricingWrap.pricingType === 'TIERED') {
      return (product.pricingWrap.tieredPrices || []).map(function (el) {
        return el.currencyCode;
      });
    }

    return (product.pricingWrap.prices || []).map(function (el) {
      return el.currencyCode;
    });
  };

  return _arrayIntersection2.default.apply(undefined, _toConsumableArray(itemConfigurations.map(_getAvailableCurrencies)));
};

exports.default = availableCurrenciesAdapter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/adapters/availableCurrenciesAdapter.js
// module id = 522
// module chunks = 3 4 5